import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { ClusterService } from '../cluster.service';
import { ClusterModel } from '../cluster.model';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { EditTranslationComponent } from '@fi-app/components/edit-translation/edit-translation.component';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';

@Component({
    selector: 'fi-cluster-edit',
    template: `
        <fi-edit-tabs
            [editTabsSettings]="editTabs"
            [moreMenuItems]="moreMenuItems"
            [isNewHeaderLayout]="true"
            (save)="save()"
        >
            <div class="content-card-wrapper ExtraLightBackgroundColor" tab0>
                <mat-card class="content-card">
                    <fi-edit-translation
                        #editTranslationComponent
                        [(names)]="cluster.Names"
                        [isLanguageSelectHiddenInMobile]="true"
                        [(descriptions)]="cluster.Descriptions"
                        [isSystemLanguage]="true"
                    >
                    </fi-edit-translation>
                </mat-card>
            </div>
        </fi-edit-tabs>
    `,
    styleUrls: ['./cluster-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-cluster-edit' },
    standalone: false,
})
export class ClusterEditComponent implements OnInit {
    @Input('cluster') cluster: ClusterModel;
    @ViewChild('editTranslationComponent') editTranslationComponent: EditTranslationComponent;
    editTabs: EditTabsModel;
    moreMenuItems: MoreMenuMobileSettingsModel;

    constructor(
        private objectTitleService: ObjectTitleService,
        private clusterService: ClusterService,
        private appTextService: AppTextService,
        private fiLoadingService: LoadingService,
        private statisticService: StatisticService,
        private saveChangesWarningService: SaveChangesWarningService,
        private stateService: FiStateService,
        private contentLanguagesService: ContentLanguagesService,
    ) {}

    ngOnInit() {
        this.setHeaderData();
        this.saveChangesWarningService.start(() => this.cluster);
        this.statisticService.Visit(ModuleType.Core, ObjectTypes.Cluster, this.cluster.Id);
    }

    private setHeaderData() {
        this.editTabs = new EditTabsModel(
            this.objectTitleService.GetTitle(this.cluster.Id, this.cluster.Name, ObjectTypes.Cluster),
        );
        this.editTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
        this.moreMenuItems = new MoreMenuMobileSettingsModel();
        this.moreMenuItems.AddListItem(this.appTextService.get('common.select_lang'), () => {
            this.openSelectLanguageDialog();
        });
    }

    private openSelectLanguageDialog() {
        this.contentLanguagesService
            .openSelectLanguageDialog(this.editTranslationComponent.ActiveItem)
            .onYesButtonClick((result: number) => (this.editTranslationComponent.ActiveItem = result));
    }

    save() {
        this.fiLoadingService.trackPromise(
            this.clusterService.SaveCluster(this.cluster).then(() => {
                this.saveChangesWarningService.stop();
                this.stateService.go(FiStateNames.Cluster.List);
            }),
        );
    }
}
